import {API} from "./API";
import {Contact} from "../models/Contact";

export class ContactsAPI extends API<Contact> {

	constructor (customerId: string) {
        let endpoint: string = 'customers/' + customerId + '/contacts';
		super(endpoint)
	}
}
